// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"524":"Product","770":"Partners","848":"Register","922":"MyAccount"}[chunkId] + "." + {"524":"59bf5ef3","770":"6323093b","848":"38772f6d","922":"df849529"}[chunkId] + ".js";
};